module.exports = __webpack_public_path__ + "img/secondary_data.134c86a2.svg";